import { aboutFacts, aboutParagraphs } from "../data/content";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import "./About.css";

export function About() {
  return (
    <section id="sobre" className="section container">
      <SectionHeader
        eyebrow="Sobre"
        title="Engenharia com leitura de negócio"
        description="Um pouco do que eu faço, como trabalho e onde entrego mais valor."
      />

      <div className="about__grid">
        <Reveal className="about__text" delay={0.05}>
          {aboutParagraphs.map((paragraph, i) => (
            <p key={i} className={i === 0 ? "about__lead" : undefined}>
              {paragraph}
            </p>
          ))}
        </Reveal>

        <Reveal className="about__facts" delay={0.12}>
          <dl>
            {aboutFacts.map((fact) => (
              <div key={fact.label} className="about__fact">
                <dt>{fact.label}</dt>
                <dd>{fact.value}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  );
}
